import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { UnespCoreEnvironment } from '@unesp/core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'
import { StatusInscricao } from '../models/status-inscricao'
import { CargaHorariaCompleto } from '../models/carga-horaria-completo'
import { Documentos } from '../models/documenos'

@Injectable({
  providedIn: 'root',
})
export class StpgService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  statusInscricao(idUnidadeUniversitaria: number, ano: number, cpf: string): Observable<StatusInscricao[]> {
    return this.http
      .get<StatusInscricao[]>(`${this.baseUrl}/stpg/status-inscricao/${idUnidadeUniversitaria}/${ano}/${cpf}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  inscricoes(search = '', page = 0, size = 10): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/stpg/inscricoes`, {
        params: new HttpParams().set('search', search).set('page', page.toString()).set('size', size.toString()),
      })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  plano(id: number): Observable<CargaHorariaCompleto> {
    return this.http
      .get<CargaHorariaCompleto>(`${this.baseUrl}/stpg/plano/${id}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  documentos(id: number): Observable<Documentos> {
    return this.http
      .get<Documentos>(`${this.baseUrl}/stpg/documentos/${id}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  certificadoDiscente(id: number): Observable<any> {
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    })
    let requestOptions = { headers: headerOptions, responseType: 'blob' as 'blob' }
    return this.http
      .get(`${this.baseUrl}/stpg/certificado-discente/${id}`, requestOptions)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  certificadoDocente(id: number): Observable<any> {
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    })
    let requestOptions = { headers: headerOptions, responseType: 'blob' as 'blob' }
    return this.http
      .get(`${this.baseUrl}/stpg/certificado-docente/${id}`, requestOptions)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  download(folder: string, idInscricao: number): Observable<any> {
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    })
    let requestOptions = { headers: headerOptions, responseType: 'blob' as 'blob' }
    return this.http
      .get(`${this.baseUrl}/stpg/download/${folder}/${idInscricao}`, requestOptions)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
